import { has, isArray } from 'lodash-es';

import {
  TOGGLE_QUICKVIEW,
  COMPANY_QUICKVIEW_REQUEST,
  COMPANY_QUICKVIEW_SUCCESS,
  COMPANY_QUICKVIEW_FAILURE,
  CANCEL_REQUEST,
} from './action-types';
import { ASSET } from '../configs/constants';
import api, { makeCompanyAssetList } from '../api';
import {
  companyDataTransformResponse,
  kpiSpotlightTransformResponse,
  mpiSpotlightTransformResponse,
  driversTransformResponse,
  pubContributionTransformResponse,
} from '../api/company-qv/transforms';

const { company_data, kpi_spotlight, mpi_spotlight, drivers, pub_contribution } = ASSET;

const { getCancelToken, cleanup } = api.buildRequestCancelation();

export const cleanupCompanyRequests = cleanup;

const assetResponseTransformers = {
  [company_data]: companyDataTransformResponse,
  [mpi_spotlight]: mpiSpotlightTransformResponse,
  [kpi_spotlight]: kpiSpotlightTransformResponse,
  [drivers]: driversTransformResponse,
  [pub_contribution]: pubContributionTransformResponse,
};

const fetchCompanyQuickview = (requestedAssets) => (dispatch, getState) => {
  const { activeEntity, permissions, data } = getState();

  let assetList = requestedAssets || makeCompanyAssetList(permissions);

  // Don't fetch company_data if present
  if (data[activeEntity.uniqKey]?.company_data) {
    assetList = assetList.filter((asset) => asset !== company_data);
  }

  const filters = {
    ...activeEntity,
    ...(data[activeEntity.uniqKey]?.company_data || {}),
  };

  assetList.forEach((asset) => {
    dispatch({
      type: COMPANY_QUICKVIEW_REQUEST,
      asset,
    });

    api
      .fetchCompanyQuickview(
        { filters, asset, permissions },
        { cancelToken: getCancelToken(asset).token }
      )
      .then((response) => {
        let responseData;

        if (isArray(response)) {
          responseData = response.reduce((acc, item) => {
            // Handle Promise.allSettled response
            if (has(item, 'status')) {
              return item.status === 'fulfilled' ? { ...acc, ...item.value.data } : acc;
            }

            // Handle regular response
            return { ...acc, ...item.data };
          }, {}); // Handle response data as an object
        } else {
          responseData = response.data;
        }

        dispatch({
          type: COMPANY_QUICKVIEW_SUCCESS,
          data: {
            [activeEntity.uniqKey]: {
              [asset]: assetResponseTransformers[asset]?.(responseData) || responseData[asset],
            },
          },
          asset,
        });

        // Request others data after company data
        if (asset === company_data) {
          dispatch(fetchCompanyQuickview());
        }
      })
      .catch((error) => {
        if (api.isCancel(error)) {
          dispatch({
            type: CANCEL_REQUEST,
            uniqKey: activeEntity.uniqKey,
          });
        } else {
          dispatch({
            type: COMPANY_QUICKVIEW_FAILURE,
            asset,
          });
        }
      });
  });
};

// Company required fields: ref_no
export const openCompanyQuickView = (company) => (dispatch, getState) => {
  const { activeEntity, data } = getState();

  // Prevent opening if already open
  if (activeEntity && activeEntity.ref_no === company.ref_no) return;

  dispatch({
    type: TOGGLE_QUICKVIEW,
    isOpen: true,
    activeEntity: {
      ...company,
      kind: 'company',
      uniqKey: company.ref_no,
    },
  });

  if (!data?.[company.ref_no]) {
    dispatch(fetchCompanyQuickview([company_data]));
  }
};
